module.exports = __webpack_public_path__ + "footer-bg.png?c43b24e818073b46e7ce8f25aedc0df5";


//////////////////
// WEBPACK FOOTER
// ./src/Footer/img/base64/footer-bg.png
// module id = 16
// module chunks = 0